import React from "react";
import QuranRecitationPopupPanel from "./QuranRecitationPopupPanel";
import QuranTafsirPopupPanel from "./QuranTafsirPopupPanel";
import QuranTranslationPopupPanel from "./QuranTranslationPopupPanel";

const QuranContentPopup = ({
  isOpen,
  uiLanguage,
  contentPopup,
  closeContentPopup,
  uiLabels,
  translationPopupDirection,
  tafsirPopupDirection,
  translationVerseWords,
  loadedPages,
  loadedFontFamilies,
  uthmanicFont,
  truncateLabel,
  translationLanguageMenuRef,
  translationOptionsLoading,
  translationLanguageMenuOpen,
  setTranslationLanguageMenuOpen,
  translationLanguageOptions,
  translationLanguageCode,
  onSelectTranslationLanguage,
  bookMenuRef,
  bookMenuSuppressUntilRef,
  translationResources,
  bookMenuOpen,
  setBookMenuOpen,
  translationResourceId,
  onSelectTranslationBook,
  tafsirLanguageMenuRef,
  tafsirOptionsLoading,
  tafsirLanguageMenuOpen,
  setTafsirLanguageMenuOpen,
  tafsirLanguageOptions,
  tafsirLanguageCode,
  onChangeTafsirLanguage,
  tafsirBookMenuRef,
  tafsirBookMenuSuppressUntilRef,
  tafsirResources,
  tafsirBookMenuOpen,
  setTafsirBookMenuOpen,
  tafsirResourceId,
  onChangeTafsirBook,
  recitationMode,
  onChangeRecitationMode,
  recitationReaderMenuRef,
  recitationReaderMenuSuppressUntilRef,
  recitationOptionsLoading,
  recitationResources,
  recitationReaderMenuOpen,
  setRecitationReaderMenuOpen,
  recitationResourceId,
  onChangeRecitationReader,
  onStartRecitationFromPopup,
}) => {
  if (!isOpen) {
    return null;
  }

  const isArabic = uiLanguage === "ar";

  return (
    <div
      className={`quran-translation-backdrop ${
        contentPopup.type === "translation" ? "quran-translation-backdrop--translation" : ""
      }`.trim()}
      onClick={closeContentPopup}
    >
      <div
        className={`quran-translation-popup ${
          contentPopup.type === "translation" ? "quran-translation-popup--translation" : ""
        } ${contentPopup.type === "recitation" ? "quran-translation-popup--recitation" : ""} ${
          (contentPopup.type === "translation" && translationPopupDirection === "ltr") ||
          contentPopup.type === "recitation"
            ? "quran-translation-popup--ltr"
            : ""
        }`.trim()}
        dir={
          contentPopup.type === "translation"
            ? translationPopupDirection
            : contentPopup.type === "recitation"
              ? "ltr"
              : contentPopup.type === "tafseer"
                ? tafsirPopupDirection
                : "rtl"
        }
        onClick={(event) => event.stopPropagation()}
      >
        <div className={`quran-popup-head ${isArabic ? "quran-overlay-head--rtl" : "quran-overlay-head--ltr"}`}>
          <div className="quran-translation-title">
            {contentPopup.type === "translation"
              ? uiLabels.translation
              : contentPopup.type === "tafseer" && contentPopup.sourceBook
                ? `${contentPopup.title} (${contentPopup.sourceBook})`
                : contentPopup.title}
          </div>
          <button
            type="button"
            className="quran-overlay-close-btn quran-popup-close"
            onClick={closeContentPopup}
          >
            {uiLabels.close}
          </button>
        </div>

        {contentPopup.type === "translation" && (
          <QuranTranslationPopupPanel
            uiLabels={uiLabels}
            translationVerseWords={translationVerseWords}
            loadedPages={loadedPages}
            loadedFontFamilies={loadedFontFamilies}
            uthmanicFont={uthmanicFont}
            truncateLabel={truncateLabel}
            translationLanguageMenuRef={translationLanguageMenuRef}
            translationOptionsLoading={translationOptionsLoading}
            translationLanguageMenuOpen={translationLanguageMenuOpen}
            setTranslationLanguageMenuOpen={setTranslationLanguageMenuOpen}
            translationLanguageOptions={translationLanguageOptions}
            translationLanguageCode={translationLanguageCode}
            onSelectTranslationLanguage={onSelectTranslationLanguage}
            bookMenuRef={bookMenuRef}
            bookMenuSuppressUntilRef={bookMenuSuppressUntilRef}
            translationResources={translationResources}
            bookMenuOpen={bookMenuOpen}
            setBookMenuOpen={setBookMenuOpen}
            translationResourceId={translationResourceId}
            onSelectTranslationBook={onSelectTranslationBook}
          />
        )}

        {contentPopup.type === "tafseer" && (
          <QuranTafsirPopupPanel
            uiLabels={uiLabels}
            truncateLabel={truncateLabel}
            tafsirLanguageMenuRef={tafsirLanguageMenuRef}
            tafsirOptionsLoading={tafsirOptionsLoading}
            tafsirLanguageMenuOpen={tafsirLanguageMenuOpen}
            setTafsirLanguageMenuOpen={setTafsirLanguageMenuOpen}
            tafsirLanguageOptions={tafsirLanguageOptions}
            tafsirLanguageCode={tafsirLanguageCode}
            onChangeTafsirLanguage={onChangeTafsirLanguage}
            tafsirBookMenuRef={tafsirBookMenuRef}
            tafsirBookMenuSuppressUntilRef={tafsirBookMenuSuppressUntilRef}
            tafsirResources={tafsirResources}
            tafsirBookMenuOpen={tafsirBookMenuOpen}
            setTafsirBookMenuOpen={setTafsirBookMenuOpen}
            tafsirResourceId={tafsirResourceId}
            onChangeTafsirBook={onChangeTafsirBook}
          />
        )}

        {contentPopup.type === "recitation" && (
          <QuranRecitationPopupPanel
            uiLabels={uiLabels}
            contentPopup={contentPopup}
            recitationMode={recitationMode}
            onChangeRecitationMode={onChangeRecitationMode}
            recitationReaderMenuRef={recitationReaderMenuRef}
            recitationReaderMenuSuppressUntilRef={recitationReaderMenuSuppressUntilRef}
            recitationOptionsLoading={recitationOptionsLoading}
            recitationResources={recitationResources}
            recitationReaderMenuOpen={recitationReaderMenuOpen}
            setRecitationReaderMenuOpen={setRecitationReaderMenuOpen}
            recitationResourceId={recitationResourceId}
            onChangeRecitationReader={onChangeRecitationReader}
            truncateLabel={truncateLabel}
            onStartRecitationFromPopup={onStartRecitationFromPopup}
          />
        )}

        <div className="quran-popup-content-scroll">
          <div className="quran-translation-meta">{uiLabels.verse}: {contentPopup.verseKey}</div>
          {contentPopup.type === "recitation" && recitationMode === "chapter" && (
            <div className="quran-translation-meta">{uiLabels.recitationChapterHint}</div>
          )}
          {contentPopup.type === "recitation" && recitationMode === "ayah" && (
            <div className="quran-translation-meta">{uiLabels.recitationAyahHint}</div>
          )}

          {contentPopup.loading && <div className="quran-translation-loading">{uiLabels.loading}</div>}

          {!contentPopup.loading && contentPopup.error && (
            <div className="quran-translation-error">{contentPopup.error}</div>
          )}

          {!contentPopup.loading && !contentPopup.error && contentPopup.type !== "recitation" && (
            <div
              className={`quran-translation-text ${
                contentPopup.type === "translation" ? "quran-translation-text--fr" : ""
              }`}
            >
              {contentPopup.text}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuranContentPopup;